/** Phase E2 — mirror backend consumer migration flags (build-time). */

export function isExecutionProjectionConsumersMode(): boolean {
  const v = process.env.REACT_APP_EXECUTION_PROJECTION_CONSUMERS;
  if (v === 'false') return false;
  return v === 'true' || process.env.REACT_APP_EXECUTION_PROJECTION_MODE === 'true';
}

export function isProjectionBasedCompletionMode(): boolean {
  const v = process.env.REACT_APP_EXECUTION_PROJECTION_COMPLETION;
  if (v === 'false') return false;
  return v === 'true' || isExecutionProjectionConsumersMode();
}

/** E2.1 dispatcher operational cockpit (projection-native UX). */
export function isOperationalCockpitMode(): boolean {
  const v = process.env.REACT_APP_OPERATIONAL_COCKPIT;
  if (v === 'false') return false;
  return v === 'true' || isExecutionProjectionConsumersMode();
}
